import { render, staticRenderFns } from "./YoutubeLinkCard.vue?vue&type=template&id=82d8197e&scoped=true&"
import script from "./YoutubeLinkCard.vue?vue&type=script&lang=js&"
export * from "./YoutubeLinkCard.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeLinkCard.vue?vue&type=style&index=0&id=82d8197e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d8197e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
